export default "__VITE_ASSET__kaOHkkYX__"